import TextWinds from '../../../components/common/TextWinds';
import '../../../styles/mypage/mypage.css';
import { orderDetailType } from '../../../constants/types/mypage-type';
import OrderDetailLayout from './OrderDetailLayout';
import { OrderStatusLabelEnum } from '../../../enum';
import { numberWithCommas } from '../../../api/utils/format/numbers';
import { TransactionBase } from '../../../constants/types';

const RefundCancelInfo = ({
  orderDetail,
}: {
  orderDetail: orderDetailType;
}) => {
  const refundInfo = (() => {
    const transaction = orderDetail.transactions.find(
      (transaction: TransactionBase) => transaction.is_refund,
    );

    return {
      accountNo: transaction?.accountNo,
      bankName: transaction?.bankName,
      depositName: transaction?.depositName,
    };
  })();

  console.log(refundInfo);

  return (
    <OrderDetailLayout title="환불/취소 정보">
      <div className="flex items-center justify-between">
        <TextWinds type="content_body4" color="gray7">
          처리 상태
        </TextWinds>
        <TextWinds type="content_body4">
          {OrderStatusLabelEnum[orderDetail.status]}
        </TextWinds>
      </div>
      <div className="flex items-center justify-between">
        <TextWinds type="content_body4" color="gray7">
          취소 금액
        </TextWinds>
        <TextWinds type="content_body4">
          {numberWithCommas(orderDetail.template.total_price)} 원
        </TextWinds>
      </div>
      {refundInfo.bankName &&
        refundInfo.accountNo &&
        refundInfo.depositName && (
          <div className="flex items-center justify-between">
            <TextWinds type="content_body4" color="gray7">
              환불 정보
            </TextWinds>
            <TextWinds type="content_body4">
              {refundInfo.bankName} {refundInfo.accountNo}{' '}
              {refundInfo.depositName}
            </TextWinds>
          </div>
        )}
    </OrderDetailLayout>
  );
};

export default RefundCancelInfo;
